import { render, staticRenderFns } from "./FootprintCard.vue?vue&type=template&id=4f87d1f7&scoped=true&lang=pug"
import script from "./FootprintCard.vue?vue&type=script&lang=js"
export * from "./FootprintCard.vue?vue&type=script&lang=js"
import style0 from "./FootprintCard.vue?vue&type=style&index=0&id=4f87d1f7&prod&lang=css"
import style1 from "./FootprintCard.vue?vue&type=style&index=1&id=4f87d1f7&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f87d1f7",
  null
  
)

export default component.exports